import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { DragAndDropIcon, DraggableComponent } from 'modules/core/components/DragAndDrop'

import { useHover } from 'modules/processes/hooks/useHover'

interface DragableItemProps extends React.PropsWithChildren {
  id: number
  position: number
}

export const DragableItem = ({ id, position, children }: DragableItemProps) => {
  const { hover, actions } = useHover()

  const backgroundColor = hover ? 'grey200' : 'grey000White'

  return (
    <DraggableComponent key={`item-${id.toString()}`} id={`item-${id.toString()}`} index={position}>
      <Box flexDirection="row" paddingLeft="s24">
        <Box
          background={backgroundColor}
          width="full"
          border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
          borderRadius={{ all: 'abs008' }}
          flexDirection="row"
          alignItems="center"
          position="relative"
          {...actions}
        >
          <Box position="absolute" paddingLeft="s4">
            <DragAndDropIcon hover={hover} />
          </Box>
          <Box width="full" paddingLeft="s8">
            {children}
          </Box>
        </Box>
      </Box>
    </DraggableComponent>
  )
}
